import ViewPage from './ViewPage.container';

export default ViewPage;
